import { useContext } from "react";
import Dashboard from "../dashboard/Dashboard";
import { AuthContext } from "../../util/context";
import Login from "../auth/Login";

export default function DashboardPage() {
  const ctx = useContext(AuthContext);
  return <>{ctx.isAuthenticated ? <Dashboard /> : <Login />}</>;
}
